import React, { Component } from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { Provider, connect } from "react-redux";
import queryString from "qs";
import { PersistGate } from "redux-persist/integration/react";

import HelpMainPage from "./Landing/HelpMainPage";
import SupportMainPage from "./Landing/SupportMainPage";
import HelpTopicList from "./Articles/HelpTopicList";
import HelpSearch from "./Search/HelpSearch";
import NewTicket from "./Tickets/NewTicket";
import NewReportTicket from "./Tickets/NewReportTicket";
import NewDeleteTicket from "./Tickets/NewDeleteTicket";
import TicketDetails from "./Tickets/TicketDetails";
import ArticleDetails from "./Articles/ArticleDetails";
import NewComment from "./Tickets/NewComment";
import { store, persistor } from "../store";
import API from "../api/api";

class FAQ extends Component {
  render() {
    return (
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter basename="/support-v2">
            <div id="faq-container">
              <div className="loader-screen">
                <div className="loader" />
              </div>
              <Route path="/" component={RouterWithStore} />
            </div>
          </BrowserRouter>
        </PersistGate>
      </Provider>
    );
  }
}

class RouterRender extends Component {
  componentDidMount() {
    const { search } = this.props.location;
    const propsUserId = this.props.userId;
    const propsUserIdv2 = this.props.userIdv2;
    let { deviceType, userId, categoryId, userIdv2, guestId, user_id } =
      queryString.parse(search, { ignoreQueryPrefix: true });
    
      if (user_id) {
      userId = user_id;
      userIdv2 = user_id;
    }

    if (!userId) userId = propsUserId;
    if (!userIdv2) userIdv2 = propsUserIdv2;

    console.log("userId", userId);
    console.log("userIdv2", userIdv2);

    if (deviceType !== undefined) {
      this.props.dispatch({ type: "SET_DEVICETYPE", payload: deviceType });
    }
    if (categoryId !== undefined) {
      this.props.dispatch({ type: "SET_CATEGORYID", payload: categoryId });
    }
    if (userId) {
      this.props.dispatch({ type: "SET_USERID", payload: userId });
      API.getUserData(userId)
        .then((data) => {
          const {
            _id,
            fName,
            lName,
            emailId,
            phoneCountryCode,
            mobile,
            helpTS,
            countryCode,
          } = data;

          this.props.dispatch({
            type: "SET_NAME",
            payload: { name: `${fName} ${lName}`, fName, lName },
          });
          this.props.dispatch({
            type: "UPDATE_HELPTS",
            payload: helpTS,
          });
          this.props.dispatch({
            type: "SET_MOBILE",
            payload: { mobile, countryCode: phoneCountryCode || countryCode },
          });
          this.props.dispatch({ type: "SET_EMAIL", payload: emailId });
        })
        .catch((err) => console.log(err));
    }
    if (userIdv2) {
      this.props.dispatch({ type: "SET_USERIDv2", payload: userIdv2 });
      API.getUserDataV2(userIdv2)
        .then((data) => {
          const {
            id,
            fName,
            lName,
            email,
            phoneCountryCode,
            mobile,
            helpTS,
            city,
            countryCode,
          } = data;

          this.props.dispatch({
            type: "SET_NAME",
            payload: { name: `${fName} ${lName}`, fName, lName },
          });
          this.props.dispatch({
            type: "UPDATE_HELPTS",
            payload: helpTS,
          });
          this.props.dispatch({
            type: "SET_MOBILE",
            payload: { mobile, countryCode: phoneCountryCode || countryCode },
          });
          this.props.dispatch({ type: "SET_EMAIL", payload: email });
          this.props.dispatch({ type: "SET_CITY", payload: city });
        })
        .catch((err) => console.log(err));
    }
    if (guestId) {
      this.props.dispatch({ type: "SET_GUESTID", payload: guestId });
      console.log(guestId);
    }
  }

  render() {
    return (
      <Switch>
        <Route exact path="/" component={HelpMainPage} />
        <Route exact path="/faqclose" component={HelpMainPage} />
        <Route exact path="/guestWriteToUs" component={HelpMainPage} />
        <Route exact path="/support" component={SupportMainPage} />
        <Route exact path="/helplist/:id" component={HelpTopicList} />
        <Route exact path="/search" component={HelpSearch} />
        <Route exact path="/newticket" component={NewTicket} />
        <Route exact path="/articledetails/:id" component={ArticleDetails} />
        <Route exact path="/ticket/:id" component={TicketDetails} />
        <Route exact path="/newcomment/:id" component={NewComment} />
        <Route exact path="/report/:repotedUser" component={NewReportTicket} />
        <Route exact path="/delete-account" component={NewDeleteTicket} />
      </Switch>
    );
  }
}

const mapStateToProps = ({ userId }) => ({ userId });

const RouterWithStore = connect(mapStateToProps)(RouterRender);

export default FAQ;



// WEBPACK FOOTER //
// ./src/components/FAQ.js